export default "__VITE_ASSET__r8Uw2L6M__"